import * as React from 'react';
import { IBButtonProps } from './Button.types';
import { Spinner } from '../Spinner';
import StyledButton from './StyledButton';

const Button: React.FC<IBButtonProps> = (props: IBButtonProps) => {
  const {
    type,
    text,
    onClick,
    className,
    disabled,
    pending,
    testId,
    startIcon,
    endIcon,
    colorType
  } = props;
  return (
    <div className={className ?? ''}>
      <StyledButton
        {...props}
        data-testid={testId || 'button'}
        className={`${className} button`}
        disabled={disabled}
        type={type}
        onClick={e => {
          if (onClick) {
            e.preventDefault();
            onClick(e);
          }
        }}
      >
        <>
          {React.isValidElement(startIcon) &&
            React.cloneElement(startIcon, {
              mr: '0.5rem'
            })}
          {pending && <Spinner buttonType={colorType} show />}
          <div className="button-text">{text}</div>
          {React.isValidElement(endIcon) &&
            React.cloneElement(endIcon, {
              ml: '0.5rem'
            })}
        </>
      </StyledButton>
    </div>
  );
};

export default Button;
